/** RTDB history/{recordId} → Türkçe zaman çizelgesi etiketleri */

export const HISTORY_TYPE_LABELS = {
  record_created: 'Başvuru alındı — OPEX ön inceleme havuzuna düştü',
  opex_rejected: 'OPEX reddetti (öneri değil / kapatıldı)',
  opex_forwarded: 'OPEX süzgecinden geçti — bölüm yöneticisine yönlendirildi',
  manager_rejected: 'Bölüm yöneticisi reddetti',
  manager_accepted: 'Bölüm yöneticisi kabul etti — uygulama planı tanımlandı',
  implementation_updated: 'Uygulama genel durumu / sonuç güncellendi',
  board_decision: 'Kurul kararı kaydedildi',
  opex_verified: 'OPEX sonucu doğruladı (ödül havuzu)',
  opex_correction: 'OPEX düzeltme istedi — lider yeniden düzenleyebilir',
}

export const getHistoryTypeLabel = (type) =>
  HISTORY_TYPE_LABELS[type] || type || 'İşlem'

export const formatHistoryWhen = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('tr-TR')
  } catch (_) {
    return String(iso)
  }
}
